export default __webpack_public_path__ + "static/media/essence_rgb.255bf875.jpg";